import { Box, Button, makeStyles, Paper, Typography, useMediaQuery } from "@material-ui/core";
import clsx from "clsx";

const useStyle = makeStyles((theme) => ({
  stepText: {
    color: theme.palette.text.hint,
    marginBottom: 15,
  },
  confirmBut: {
    marginBottom: "10px",
    width: "150px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  paper: {
    filter: "blur(4px)",
    cursor: "not-allowed",
  },
}));

export default function BaseStep({ children, des, startComponent, butProps, boxButProps, ...props }) {
  const cls = useStyle();
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <Paper {...props} className={clsx({ [cls.paper]: props?.isBlur }, props?.className)}>
      {isMobile && (
        <Typography className={cls.stepText} variant="subtitle2">
          {des}
        </Typography>
      )}
      {children}
      <Box display="flex" flexDirection={isMobile ? "column" : "row"} mt={2} {...boxButProps}>
        <Box
          display="flex"
          justifyContent="flex-start"
          width={isMobile ? "100%" : "50%"}
          mb={isMobile && Boolean(startComponent) ? 1 : 0}
        >
          {startComponent}
        </Box>
        <Box display="flex" justifyContent="flex-end" width={isMobile ? "100%" : "50%"}>
          <Button variant="contained" color="primary" className={cls.confirmBut} {...butProps}>
            {butProps?.text ?? "Confirm"}
          </Button>
        </Box>
      </Box>
    </Paper>
  );
}
